<script>
    import FileDetails from "./FileDetails.svelte";
    import FileActivity from "./FileActivity.svelte";
    import { t } from "../../../i18n";
</script>

<div class="app-file-sidebar-info">
    <div class="card shadow-none mb-0 p-0 pb-1">
        <div class="card-header d-flex justify-content-between align-items-center border-bottom">
            <h6 class="mb-0">Document.pdf</h6>
            <div class="app-file-action-icons d-flex align-items-center">
                <!-- <i class="bx bx-trash cursor-pointer mr-50"></i> -->
                <i class="bx bx-x close-icon cursor-pointer"></i>
            </div>
        </div>
        <div class="card-content">
            <ul class="nav nav-tabs justify-content-center" role="tablist">
                <li class="nav-item mr-1 pt-50 pr-1 border-right">
                    <a class=" nav-link active d-flex align-items-center" id="details-tab" data-toggle="tab" href="#details" aria-controls="details" role="tab" aria-selected="true">
                        <i class="bx bx-file mr-50"></i>{$t('files.details')}
                    </a>
                </li>
                <li class="nav-item pt-50 ">
                    <a class=" nav-link d-flex align-items-center" id="activity-tab" data-toggle="tab" href="#activity" aria-controls="activity" role="tab" aria-selected="false">
                        <i class="bx bx-pulse mr-50"></i>{$t('files.activity')}
                    </a>
                </li>
            </ul>
            <div class="tab-content pl-0">
                <FileDetails></FileDetails>
                <FileActivity></FileActivity>
            </div>
        </div>
    </div>
</div>